import { AppBar } from '@material-ui/core';
import styled from 'styled-components';

export const StyledHeader = styled(AppBar)`
	box-shadow: none !important;
	background-color: ${({ theme }) => theme.landing_page_colors.primary} !important;
	left: 0 !important;
	right: auto !important;
`;
